// File: src/Pages/AboutPage.jsx
import React, { useState, useEffect, useRef } from "react";
import "./AboutPage.css"; // create this CSS file to move styles from outerHTML

const AboutPage = () => {
  // Carousel state
  const [index, setIndex] = useState(0);
  const wrapperRef = useRef(null);

  const carouselItems = [
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_16.png?v=1724918291",
      link: "https://lumenaura.com/news/press-1",
      alt: "media brief",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_15.png?v=1724918410",
      link: "https://lumenaura.com/news/press-2",
      alt: "HAF",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_14.png?v=1724918519",
      link: "https://lumenaura.com/news/press-3",
      alt: "BRANDZ MAGAZINE",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/default.png?v=1724918590",
      link: "https://www.instagram.com/p/C_Kb57RqKs3/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      alt: "INC42",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/logo-bg-01.png?v=1724918648",
      link: "https://lumenaura.com/news/press-4",
      alt: "Business Standard",
    },
    // duplicate logos for continuous effect
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_18.png?v=1724918710",
      link: "https://lumenaura.com/news/press-5",
      alt: "AD GULLY",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/headerV3_YS-01.png?v=1724918785",
      link: "https://lumenaura.com/news/press-6",
      alt: "YOUR STORY",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_13.png?v=1724918870",
      link: "https://lumenaura.com/news/press-7",
      alt: "Orris Diary",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/retail-logo-header-01.png?v=1724918958",
      link: "https://lumenaura.com/news/press-8",
      alt: "Economic Times",
    },
    {
      img: "https://cdn.shopify.com/s/files/1/0878/6981/7120/files/Asset_19.png?v=1724919014",
      link: "https://lumenaura.com/news/press-9",
      alt: "Bollywood Hungama",
    },
  ];

  // Carousel handlers
  const showNext = () => setIndex((prev) => (prev + 1) % carouselItems.length);
  const showPrev = () =>
    setIndex((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % carouselItems.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  return (
    <main className="main-content">
      <div style={{marginTop: '25px'}}>
        {/* Section: About Us */}
        <section className="section-padding about-section">
          <div className="wrapper text-left">
            <h2 className="section-title">About Us</h2>
            <p>
              LumenAura is a fragrance house founded with a passion for crafting
              unforgettable scents that embody elegance, sophistication, and
              individuality. LumenAura marks an exciting expansion into the world of
              high-end perfumes.
            </p>
            <p>
              At LumenAura, we believe that a fragrance is more than just a scent;
              it's an experience, a statement, and a reflection of one's personality.
              Our collection features meticulously crafted perfumes designed for
              every occasion, ensuring you always have the perfect scent to
              complement your style.
            </p>
          </div>
        </section>

        {/* Section: Our Story */}
        <section className="section-padding story-section">
          <div className="wrapper text-left">
            <h2 className="section-title">Our Story</h2>
            <p>
              LumenAura was born from a passion for excellence and a desire to bring
              the finest fragrances to life. Our journey began with the vision to
              create a brand that offers not just perfumes, but an olfactory
              experience that captivates and inspires. Drawing on the rich heritage
              and expertise of fragrance artisans, we have seamlessly blended
              artistry with craftsmanship to develop a line of perfumes that are both
              timeless and contemporary.
            </p>
          </div>
        </section>

        {/* Section: Our Commitment */}
        <section className="section-padding commitment-section">
          <div className="wrapper text-left">
            <h2 className="section-title">Our Commitment</h2>
            <p>
              At LumenAura, we are dedicated to quality and sustainability. Our
              perfumes are crafted using the finest ingredients, ensuring a
              long-lasting and memorable scent.
            </p>
          </div>
        </section>

        {/* Section: Brand Ambassador */}
        <section className="section-padding ambassador-section">
          <div className="wrapper dual-block">
            <div className="image-block">
              <img
                src="https://picsum.photos/seed/lumenaura-ambassador/800/500"
                alt="KL Rahul"
              />
            </div>
            <div className="text-block">
              <h2 className="section-title">Meet Our Brand Ambassador</h2>
              <p>
                We are proud to have renowned cricketer KL Rahul as our brand ambassador
                and investor. His dedication, passion, and excellence on and off the
                field perfectly align with the values of LumenAura.
              </p>
            </div>
          </div>
        </section>

        {/* Section: Join Our Journey */}
        <section className="section-padding journey-section">
          <div className="wrapper dual-block reverse">
            <div className="image-block">
              <img
                src="https://picsum.photos/seed/lumenaura-journey/800/500"
                alt="LumenAura Journey"
              />
            </div>
            <div className="text-block">
              <h2 className="section-title">Join Us on Our Journey</h2>
              <p>
                Experience the magic of LumenAura and let your scent tell your story.
                Explore our collection and find your perfect fragrance today. Whether
                you're looking to make a statement, create lasting memories, or simply
                indulge in a moment of luxury, Ha1o is here to elevate your everyday
                life.
              </p>
              <p>
                For more information or to shop our collection, visit{" "}
                <a
                  href="https://lumenaura.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  lumenaura.com
                </a>
              </p>
            </div>
          </div>
        </section>

        {/* Section: Carousel */}
        <section className="carousel-container">
          <h4>Featured In</h4>
          <div
            className="carousel-wrapper"
            ref={wrapperRef}
            style={{
              transform: `translateX(-${index * 170}px)`,
              transition: "transform 0.5s ease-in-out",
            }}
          >
            {carouselItems.map((item, i) => (
              <a
                key={i}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="carousel-item"
              >
                <img src={item.img} alt={item.alt} />
              </a>
            ))}
          </div>
          <div className="carousel-navigation">
            <button className="nav-button" onClick={showPrev}>
              ❮
            </button>
            <button className="nav-button" onClick={showNext}>
              ❯
            </button>
          </div>
        </section>
      </div>
    </main>
  );
};

export default AboutPage;
